import { Dropdown } from "@carbon/react";
import { Control, Controller } from "react-hook-form";

import { useT } from "src/internationalization";
import { Property } from "src/types/property";

import { RuleFormData } from "./useRuleDefinition";

type RulePropertyFormFieldProps = {
  index: number;
  id: string;
  items: Property[];
  control: Control<RuleFormData, undefined, RuleFormData>;
};

export function RulePropertyFormField({ index, id, control, items }: RulePropertyFormFieldProps) {
  const t = useT();
  return (
    <Controller
      name={`criteria.${index}.property`}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <Dropdown
            id={`property-${id}`}
            titleText={t("page.rules.modal.create.form.filters.property.label")}
            label={t("page.rules.modal.create.form.filters.property.placeholder")}
            items={items}
            itemToString={(item) => item?.name || ""}
            selectedItem={items.find((property) => property.code === field.value?.code) ?? null}
            onChange={({ selectedItem }) => {
              field.onChange({
                dataType: selectedItem?.dataType,
                confListCode: selectedItem?.confListCode,
                code: selectedItem?.code,
              });
            }}
            invalid={!!fieldState.error}
            invalidText={fieldState.error?.message}
          />
        );
      }}
    />
  );
}
